export * from "./IconLogo";
